import { ReactNode } from 'react';
import { KaiProApiStateProvider } from '../../contexts';

type WebKaiProApiStateProviderProps = {
  children: ReactNode;
};

const getIsOffline = () => typeof navigator !== 'undefined' ? !navigator.onLine : false;

export const WebKaiProApiStateProvider = ({ children }: WebKaiProApiStateProviderProps) => (
  <KaiProApiStateProvider
    init={async (setIsOffline: (isOffline: boolean) => void) => {
      setIsOffline(getIsOffline());

      const updateIsOffline = () => setIsOffline(getIsOffline());
      window.addEventListener('online', updateIsOffline);
      window.addEventListener('offline', updateIsOffline);

      return ({
        isOffline: getIsOffline(),
        cleanup: () => {
          window.removeEventListener('online', updateIsOffline);
          window.removeEventListener('offline', updateIsOffline);
        },
      });
    }}
  >
    {children}
  </KaiProApiStateProvider>
);
